import { render, staticRenderFns } from "./receiptList.vue?vue&type=template&id=cf53bef0&scoped=true"
import script from "./receiptList.vue?vue&type=script&lang=js"
export * from "./receiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf53bef0",
  null
  
)

export default component.exports